import { useJsApiLoader, type Libraries } from "@react-google-maps/api";

import { env } from "@/env";

const API_KEY = env.NEXT_PUBLIC_GMAPS_API_KEY!;
const gmapsLibraries: Libraries = ["places", "geocoding"];

/**
 * Custom hook to load the Google Maps API
 *
 * @returns {boolean} isLoaded - Whether the Google Maps API has been loaded
 */
export const useGoogleMapsApi = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: API_KEY,
    libraries: gmapsLibraries,
  });

  return {
    gmapsApiIsLoaded: isLoaded,
  };
};
